import { ShopkeeperUpdateCheckResponse } from './../shared/models/shopkeeper/shopkeeper-update-chek-response.type';
import { take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Originador } from '../services/pesados-brasil/originador.interface';
import { LoginAgente } from './model/login-agente';
import { LoginUsuarioTO } from './model/login-usuario-to';
import { StorageService } from '../services/storage/storage.service';

const USER = 'id_session';
const AGENTE = 'id_session_ag';
const REDIRECT_ROUTE = 'id_redirect_route';
const ORIGINATOR = 'id_session_or';
const EXPIRATION = 'id_expiration';
const SIMULACAO_TENTATIVAS = 'simulacaoTentativas';
const SIMULACAO_TEMPO = 'simulacaoTempo';
const ITENS_PAGINA_HOME = 'itensPorPagina';
const POSSUI_CDC_LOJA_OU_PREMIUM = 'possuiCdcLojaOuPremium';
const TIPOS_PRODUTOS = 'tiposProdutos';
const SHOPKEEPER_INFO = 'shopkeeper_info';
@Injectable()
export class LoginStorage {
  constructor(private readonly service: StorageService) {}

  register(usuario: LoginUsuarioTO) {
    this.setStorage(USER, usuario);
  }

  registerAgente(agente: LoginAgente) {
    this.setStorage(AGENTE, agente);
  }

  registerRedirectRoute(route: string) {
    this.setStorage(REDIRECT_ROUTE, route);
  }

  registerOriginator(originator: Originador) {
    this.setStorage(ORIGINATOR, originator);
  }

  registerDataExpiracao(dataExpiracao: number) {
    sessionStorage.setItem(EXPIRATION, dataExpiracao.toString());
  }

  registerOptions(options: string[]) {
    sessionStorage.setItem('options', JSON.stringify(options));
  }
  

  clear(): void {
    sessionStorage.removeItem(USER);
    sessionStorage.removeItem(AGENTE);
    sessionStorage.removeItem(ORIGINATOR);
    sessionStorage.removeItem(EXPIRATION);
    sessionStorage.removeItem(SIMULACAO_TEMPO);
    sessionStorage.removeItem(SIMULACAO_TENTATIVAS);
    sessionStorage.removeItem(ITENS_PAGINA_HOME);
    sessionStorage.removeItem(POSSUI_CDC_LOJA_OU_PREMIUM);
    sessionStorage.removeItem(SHOPKEEPER_INFO);
  }

  clearOptions(): void {
    sessionStorage.removeItem('options');
  }

  clearRedirectRoute() {
    sessionStorage.removeItem(REDIRECT_ROUTE);
  }

  isContainsToken(): boolean {
    return (
      this.usuario.token &&
      this.usuario.token !== 'undefined' &&
      this.usuario.token.trim().length > 0 &&
      !this.isTokenExpired()
    );
  }

  isTokenExpired(): boolean {
    let expirationDate: number = this.dataExpiracao;

    if (expirationDate > 0) {
      return Date.now() > expirationDate;
    }
    if (this.login && this.token) {
      this.service
        .renewUser(this.loginAndTokenAsJson)
        .pipe(take(1))
        .subscribe(
          (result) => {
            this.register(result.usuario);
            this.registerDataExpiracao(result.dataExpiracao);
            expirationDate = result.dataExpiracao;
            return Date.now() > expirationDate;
          },
          (error) => {
            return true;
          }
        );
    } else {
      return false;
    }
  }

  get token(): string {
    return this.usuario.token;
  }

  get login(): string {
    return this.usuario.login;
  }

  get operador(): number {
    return this.usuario.operador;
  }

  get agenteId(): number {
    return this.agente.id;
  }

  get loginAndTokenAsJson(): string {
    const usuario: LoginUsuarioTO = this.usuario;
    // return JSON.stringify({ login: usuario.login, token: usuario.token, agente: this.agenteId, operador: this.operador });
    return JSON.stringify({ login: usuario.login, token: usuario.token });
  }

  get usuario(): LoginUsuarioTO {
    return new LoginUsuarioTO(this.getStorage(USER));
  }

  get agente(): LoginAgente {
    return this.getStorage(AGENTE);
  }

  get redirectRoute(): string {
    return this.getStorage(REDIRECT_ROUTE);
  }

  get originator(): Originador {
    return this.getStorage(ORIGINATOR);
  }

  get options(): string[] {
    return sessionStorage.getItem('options') ? JSON.parse(sessionStorage.getItem('options')) : [];
  }

  get dataExpiracao(): number {
    return Number(sessionStorage.getItem(EXPIRATION));
  }

  private setStorage(key: string, value: any) {
    sessionStorage.setItem(key, btoa(JSON.stringify(value)));
  }

  private getStorage(key: string): any {
    const value = sessionStorage.getItem(key);
    if (value) {
      return JSON.parse(atob(value));
    }
    return {};
  }

  registerSimulacaoTentativas(valor: number) {
    sessionStorage.setItem(SIMULACAO_TENTATIVAS, valor.toString());
  }

  registerSimulacaoTempo(valor: number) {
    sessionStorage.setItem(SIMULACAO_TEMPO, valor.toString());
  }

  get simulacaoTentativas(): number {
    return Number(sessionStorage.getItem(SIMULACAO_TENTATIVAS));
  }

  get simulacaoTempo(): number {
    return Number(sessionStorage.getItem(SIMULACAO_TEMPO));
  }

  registerItensPaginaHome(valor: string) {
    sessionStorage.setItem(ITENS_PAGINA_HOME, valor);
  }

  get itensPorPagina(): string {
    return sessionStorage.getItem(ITENS_PAGINA_HOME);
  }

  registerPossuioCDCLojaOuPremium(valor: boolean) {
    sessionStorage.setItem(POSSUI_CDC_LOJA_OU_PREMIUM, valor.toString());
  }

  get possuiCdcLojaOuPremium(): boolean {
    return sessionStorage.getItem(POSSUI_CDC_LOJA_OU_PREMIUM) === 'true';
  }

  registerTiposProdutos(valor: string) {
    sessionStorage.setItem(TIPOS_PRODUTOS, valor);
  }

  get tiposProdutos(): string {
    return sessionStorage.getItem(TIPOS_PRODUTOS);
  }

  registerShopkeeperInfo(value: ShopkeeperUpdateCheckResponse) {
    sessionStorage.setItem(SHOPKEEPER_INFO, JSON.stringify(value));
  }

  get shopkeeperInfo(): ShopkeeperUpdateCheckResponse {
    return JSON.parse(sessionStorage.getItem(SHOPKEEPER_INFO));
  }
}
